import { RouteRecordRaw } from "vue-router";
const Dashboard = () => import("@/views/DashboardView.vue");
const LayoutsLogin = () => import("@/views/LayoutsLoginView.vue");
const routes: RouteRecordRaw[] = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => Dashboard(),
    children: [
      /*Pagina pricipal*/
      {
        path: "/dashboard",
        name: "dashboard",
        meta: {
          breadcrumbs: [
            { title: `Inicio`, disabled: true, href: "/dashboard" },
          ],
        },
        component: () => import("../views/CalendarView.vue"),
      },
      /* CIRUGIAS */
      {
        path: "/programar",
        name: "Programar cirugia",
        meta: {
          breadcrumbs: [
            { title: `Inicio`, disabled: true, href: "/dashboard" },
          ],
        },
        component: () => import("../views/CirugiasView.vue"),
      },
      /* CITAS */
      {
        path: "/citas",
        name: "Citas programadas",
        meta: {
          breadcrumbs: [
            { title: `Inicio`, disabled: true, href: "/dashboard" },
          ],
        },
        component: () => import("../views/CitaView.vue"),
      },

      /* DIagnostico */
      {
        path: "/diagnosts",
        name: "Lista de diagnostico",
        meta: {
          breadcrumbs: [
            {
              title: `Lista de diagnostico`,
              disabled: false,
              href: "/diagnosts",
            },
          ],
        },
        component: () => import("../views/diagnosts/ListView.vue"),
      },
      /*Reportes*/
      {
        path: "/reportes",
        name: "Reportes",
        meta: {
          breadcrumbs: [
            { title: `Inicio`, disabled: true, href: "/dashboard" },
          ],
        },
        component: () => import("../views/reportes/reportmixView.vue"),
      },
      /*Perfil del paciente*/
      {
        path: "/pacientes/:id/profile",
        name: "Perfil del paciente",
        meta: {
          breadcrumbs: [
            { title: `Lista de paciente`, disabled: true, href: "/pacientes" },
            {
              title: `Perfil del paciente`,
              disabled: false,
              href: "/pacientes/profile",
            },
          ],
        },
        component: () => import("../views/pacientes/ProfileView.vue"),
      },

      /*PACIENTES*/
      {
        path: "/pacientes",
        name: "Lista de pacientes",
        meta: {
          breadcrumbs: [
            { title: `Lista de pacientes`, disabled: true, href: "/pacientes" },
          ],
        },
        component: () => import("../views/pacientes/ListView.vue"),
      },
    ],
  },
  {
    path: "/setting",
    redirect: "/setting",
    component: () => Dashboard(),
    children: [
      {
        path: "",
        component: () => import("../views/SettingView.vue"),
        children: [          
          /* Cirugias */
            {
            path: "/cirugias",
            name: "Cirugias",
            meta: {
              breadcrumbs: [
                {
                  title: `Lista de cirugia`,
                  disabled: true,
                  href: "/cirugias",
                },
              ],
            },
            component: () => import("../views/cirugias/ListView.vue"),
          },
          /* Clientes */
          {
            path: "/clientes",
            name: "Clientes",
            meta: {
              breadcrumbs: [
                {
                  title: `Lista de clientes`,
                  disabled: true,
                  href: "/cirugias",
                },
              ],
            },
            component: () => import("../views/clientes/ListView.vue"),
          },
          /*Reportes*/
          {
            path: "/tipoespecialidad",
            name: "Especialidad",
            meta: {
              breadcrumbs: [
                {
                  title: `Lista de especialidad`,
                  disabled: true,
                  href: "/tipoespecialidad",
                },
              ],
            },
            component: () => import("../views/tipoespecialidads/ListView.vue"),
          },
          /* Tipo de referido */
          {
            path: "/tiporeferidos",
            name: "Tipo de referido",
            meta: {
              breadcrumbs: [
                {
                  title: `Tipo de referidos`,
                  disabled: true,
                  href: "/tiporeferidos",
                },
              ],
            },
            component: () => import("../views/tiporeferidos/ListView.vue"),
          },
          /* Forma de pago */
          {
            path: "/formpagos",
            name: "Modo de pago",
            meta: {
              breadcrumbs: [
                { title: `Modo de pago`, disabled: true, href: "/formapagos" },
              ],
            },
            component: () => import("../views/formpagos/ListView.vue"),
          },
          /* Personal */
          {
            path: "/personals",
            name: "Lista de personal clinico",
            meta: {
              breadcrumbs: [
                {
                  title: `Lista de personal clinico`,
                  disabled: true,
                  href: "/personals",
                },
              ],
            },
            component: () => import("../views/personals/ListView.vue"),
          },
          /* POBLACION */
          {
            path: "/poblacions",
            name: "Lista de poblacion",
            meta: {
              breadcrumbs: [
                {
                  title: `Lista de poblacion`,
                  disabled: true,
                  href: "/poblacions",
                },
              ],
            },
            component: () => import("../views/poblacions/ListView.vue"),
          },
          /* Profesion */
          {
            path: "/profesions",
            name: "Lista de profesiones",
            meta: {
              breadcrumbs: [
                {
                  title: `Lista de profesiones`,
                  disabled: true,
                  href: "/profesions",
                },
              ],
            },
            component: () => import("../views/profesions/ListView.vue"),
          },
          /* Roles/Grupos */
          {
            path: "/roles",
            name: "Rol/Grupo",
            meta: {
              breadcrumbs: [
                { title: `Lista de Rol/Grupo`, disabled: true, href: "/roles" },
              ],
            },
            component: () => import("../views/roles/ListView.vue"),
          },
          /* USUARIOS */
          {
            path: "/users",
            name: "Lista de usuario",
            meta: {
              breadcrumbs: [
                { title: `Lista de usuario`, disabled: true, href: "/users" },
              ],
            },
            component: () => import("../views/users/ListView.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/auth",
    component: () => LayoutsLogin(),
    children: [
      {
        path: "login",
        name: "Login",
        component: () => import("../components/LoginTemp.vue"),
        meta: {
          isPublic: true,
        },
      },
    ],
  },
];
export default routes;
